<template lang="html">
  <section :id="id">
    <base-modal
      ref="baseModal"
      :maxHeight="modalHeight"
      :maxWidth="modalWidth"
      @on-base-modal-close="cancelModal"
    >
      <!-- header  -->
      <template v-slot:header>
        <div class="m-title">
          {{ getMessageText(messages.DISP_EL_PROGRESS) }}
        </div>
      </template>

      <element-description
        v-if="isReady"
        :label="descriptionText"
        :outer-container-class="'m-items'"
        :elem-description="desc"
        :value-container-class="'mt8 obj-select'"
        :focus="true"
        @on-element-description-changed="onDeDescriptionChanged"
      ></element-description>

      <div class="m-items">
        <div class="label-wrapper">
          <div class="label">
            {{ getMessageText(messages.PROGRESS_VALUE_LABEL) }}:
          </div>
        </div>
        <div class="expression">
          <expressions
            v-if="isReady"
            id="expression1"
            :data-elements="allSources"
            :selected-source="selectedSource"
            :data-type="'number'"
            :initial-expression="expression1"
            :is-global="true"
            :content-type="appContent.type"
            @on-expression-field-valid="onConfigExpressionValid"
          />
        </div>
      </div>

      <div class="m-items">
        <div class="label-wrapper">
          <div class="label">
            {{ getMessageText(messages.PROGRESS_GOAL_LABEL) }}:
          </div>
        </div>
        <div class="expression">
          <expressions
            v-if="isReady"
            id="expression2"
            :data-elements="allSources"
            :selected-source="selectedSource"
            :data-type="'number'"
            :initial-expression="expression2"
            :is-global="true"
            :content-type="appContent.type"
            @on-expression-field-valid="onConfigExpressionValid"
          />
        </div>
      </div>

      <div class="m-items">
        <div class="label-wrapper">
          <div class="label progress-overflow">
            {{ getMessageText(messages.PROGRESS_OVERFLOW) }}:
          </div>
        </div>
        <div class="overflow-expression">
          <b-form-checkbox v-model="overflowValue"></b-form-checkbox>
        </div>
      </div>

      <!-- footer  -->
      <template v-slot:footer>
        <div class="m-group-btns">
          <button class="m-button neutral" @click="cancelModal">
            {{ getMessageText(messages.CANCEL) }}
          </button>
          <button
            class="m-button brand"
            @click="createBtn"
            :disabled="isSubmitDisabled"
          >
            {{ getMessageText(messages.OK) }}
          </button>
        </div>
      </template>
    </base-modal>
  </section>
</template>

<script lang="js">
  import store from "@/store";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import dragAndDrop from "@/views/drag-drop-pages/components/utils/dragAndDrop";
  import BaseModal from "@/views/drag-drop-pages/components/modal/BaseModal";
  import Expressions from "@/components/Expressions"
  import ElementDescription from "@/components/ElementDescription";

  export default  {
    name: "add-progress-chart-modal",
    components: {
      BaseModal,
      Expressions,
      ElementDescription
    },
    props: {
      id: {
        type: String
      },
      editData: {
        type: Object
      }
    },
    mounted () {
      if(this.editData) {
        this.expression1 = this.editData.props.value;
        this.expression2 = this.editData.props.goal;
        this.overflowValue = this.editData.props.overflow;
        this.onDeDescriptionChanged(this.editData.props.description)
      }
      this.isReady = true;
    },
    computed: {
      messages() {
        return store.state.messages;
      },
      isSubmitDisabled() {
        return !this.expression1 || !this.expression2;
      },
      level() {
        return 1;
      },
      selectedSource() {
        return {
          fields: {}
        }
      },
      appId() {
        return dragAndDrop.getAppId();
      },
      appContent() {
        return JSON.parse(JSON.stringify(expressionBuilder.getAppContent(this.appId)));
      },
      allSources() {
        let output = null;
        if (this.appContent) {
          output = this.appContent.dataElements || {};
        } else {
          console.error(`No app content found for appId ${this.appId}`);
        }
        return output;
      },
      desc() {
        return this.editData ? this.editData.props.description : "";
      },
      descriptionText() {
        return this.getMessageText(this.messages.DESCRIPTION);
      }
    },
    data () {
      return {
        modalHeight: 500,
        modalWidth: 700,
        expression1: null,
        expression2: null,
        overflowValue: false,
        isReady: false,
        elementDescription: null
      }
    },
    methods: {
      cancelModal() {
        const EVENT = "on-add-modal-close";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          dragAndDrop.makeAllComponentsDraggable();
          this.$emit(EVENT, {id: this.id});
        }
      },
      createBtn() {
        const obj = {
          modal: {
            id: this.id,
            create: "ProgressChart",
            editElementId: this.editData ? this.editData.id: null
          },
          props: {
            description: this.elementDescription,
            data: {
              value: this.expression1,
              goal: this.expression2,
              overflow: this.overflowValue
            }
          }
        };
        const EVENT = "on-add-modal-done";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          dragAndDrop.makeAllComponentsDraggable();
          this.$emit(EVENT, obj);
        }
      },

      onConfigExpressionValid(ctx) {
        const expValue = ctx.status ? ctx : null;

        if(ctx.id === "expression1") {
          this.expression1 = expValue ? expValue.confExpression : null;
        } else {
          this.expression2 = expValue ? expValue.confExpression : null;
        }
      },
      onDeDescriptionChanged(input) {
        this.elementDescription = input;
      }
    }
  }
</script>

<style scoped lang="scss">
  .m-items {
    grid-template-columns: 6rem auto;
    margin-bottom: 10px;
    color: var(--DEFAULT_TEXT_BLACK);
    .label {
      overflow-wrap: anywhere;
      padding-top: 0.3rem;
    }
    .label-wrapper {
      padding-right: 1rem;
    }
    .expression,
    .label {
      display: flex;
      align-items: center;
      min-height: 2.5rem;
    }
    .overflow-expression {
      display: flex;
      align-items: center;
    }
    .progress-overflow {
      padding-top: 0;
    }
  }
  .m-title {
    text-align: left;
  }
</style>
